export const downloadFile = (
  data: string,
  { name = 'file', extension = 'txt' }: { name?: string; extension?: string },
) => {
  const downloadUrl = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', `${name}.${extension}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
